import React from "react";
import { Link } from "react-router-dom";
import Wordmark from "../components/Brand/Wordmark";
import { useDocumentMeta } from "../lib/useDocumentMeta";

/*
 * Velaigal 404. Restrained on purpose — a single centered column, the
 * mark, an eyebrow, one line explaining the miss, and one primary way
 * back (home) with a quieter secondary way to keep going (jobs).
 */
const NotFound: React.FC = () => {
  useDocumentMeta("Page not found · Velaigal");

  return (
    <div className="min-h-screen w-full bg-cream flex items-center justify-center px-6">
      <div className="max-w-md text-center">
        <Wordmark variant="mark" size="lg" />
        <span className="label-editorial block mt-8">404</span>
        <h1 className="font-display text-3xl font-medium text-ink tracking-tight mt-4">
          Page not found.
        </h1>
        <span aria-hidden="true" className="block w-12 h-px bg-saffron mx-auto mt-6" />
        <p className="mt-6 text-base text-ink-secondary leading-relaxed">
          That page does not exist, or it moved when we rebuilt the
          platform. Let's get you back on track.
        </p>

        <div className="mt-10 flex flex-col items-center gap-4">
          <Link to="/" className="btn-primary">
            Back to home
          </Link>
          <Link
            to="/jobs"
            className="velaigal-link text-sm font-medium"
          >
            Browse jobs
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
